import { deleteDB } from 'idb';

export const RETIRED_PERSONAL_TEXT_PROVIDER_STORAGE_KEY =
  'affine:personal-text-provider:v1';
export const RETIRED_PERSONAL_EMBEDDING_PROVIDER_STORAGE_KEY =
  'affine:personal-embedding-provider:v1';
export const RETIRED_PERSONAL_VECTOR_INDEX_DATABASE =
  'affine:personal-vector-index:v1';

export function clearRetiredBrowserAiStorage(storage?: Storage) {
  const browserStorage =
    storage ??
    (typeof window === 'undefined'
      ? null
      : (() => {
          try {
            return window.localStorage;
          } catch {
            return null;
          }
        })());
  if (!browserStorage) return;

  for (const key of [
    RETIRED_PERSONAL_TEXT_PROVIDER_STORAGE_KEY,
    RETIRED_PERSONAL_EMBEDDING_PROVIDER_STORAGE_KEY,
  ]) {
    try {
      browserStorage.removeItem(key);
    } catch {
      // A storage implementation may reject access; there is no supported
      // browser-local route left to recover from it.
    }
  }
}

export async function retireLegacyBrowserAiSettings(storage?: Storage) {
  clearRetiredBrowserAiStorage(storage);
  if (typeof indexedDB === 'undefined') return;
  try {
    await deleteDB(RETIRED_PERSONAL_VECTOR_INDEX_DATABASE);
  } catch {
    // Deletion can be blocked by another tab. The runtime never opens this
    // database again, so a later page load can retry the cleanup.
  }
}
